import React from 'react';
export function TopBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-violet-900 text-white py-3 px-4" data-id="element-124">
      <div className="max-w-7xl mx-auto text-center" data-id="element-125">
        <p className="text-sm md:text-base font-semibold tracking-wide" data-id="element-126">
          ⚡ MIÉRCOLES 22 DE ABRIL · 7:30 PM · CUPOS LIMITADOS
        </p>
      </div>
    </div>;
}